import React from 'react'

const Footer = () => {
  return (
    <footer>
      <p>Built by Jamie Spencer · Created 2026 · <span>v1.0</span> · Hammond, LA</p>
    </footer>
  )
}

export default Footer